export const STORAGE_KEYS = {
  AUTH: 'jornadaser-admin',
};
